import { atom, RecoilState, selector } from 'recoil';
import { Brand } from '../../containers_v2/globals/Model';
import { getBrandsData } from '../../containers_v2/products/action';
import { Atoggle } from '../global/Toggle';
import { AtomCategory, AtomState } from '../utils/model/Model';

const AglobalBrand: AtomState<Brand[] | undefined> = {
	category: AtomCategory.GLOBAL,
	atom: atom({
		key: 'atom_global_brand', // UNIQUE ID
		default: undefined
	})
};

const AreportBrand: AtomState<Brand[] | undefined> = {
	category: AtomCategory.REPORTS,
	atom: atom({
		key: 'atom_report_brand', // UNIQUE ID
		default: undefined
	})
};

const ABrandFilter: RecoilState<Brand[] | undefined> = selector({
	key: 'atom_brand',
	get: ({ get }) => {
		const category: AtomCategory = get(Atoggle);
		return getAtom(category);
	},
	set: ({ get, set }, newValue) => {
		const category: AtomCategory = get(Atoggle);
		set(getAtom(category), newValue);
	}
});

const ABrand = selector<Brand[] | undefined>({
	key: 'atom_brand_selector',
	get: async() => getBrandsData()
});

function getAtom(category: AtomCategory): RecoilState<Brand[] | undefined> {
	switch (category) {
		case AtomCategory.GLOBAL:
			return AglobalBrand.atom;
		case AtomCategory.REPORTS:
			return AreportBrand.atom;

		default:
			return AglobalBrand.atom;
	}
}

const AglobalAllBrands: AtomState<boolean> = {
	category: AtomCategory.GLOBAL,
	atom: atom({
		key: 'atom_global_all_brands', // UNIQUE ID
		default: true,
	})
};

const AAllBrands = selector<boolean>({
	key: 'atom_all_brands',
	get: ({ get }) => get(AglobalAllBrands.atom),
	set: ({ set }, newValue) => set(AglobalAllBrands.atom, newValue)
});

const AGlobalEmptyBrand: AtomState<boolean> = {
	category: AtomCategory.GLOBAL,
	atom: atom({
		key: 'atom_global_empty_brands', // UNIQUE ID
		default: true,
	})
};

const AEmptyBrand = selector<boolean>({
	key: 'atom_empty_brand',
	get: ({ get }) => get(AGlobalEmptyBrand.atom),
	set: ({ set }, newValue) => set(AGlobalEmptyBrand.atom, newValue)
});

export {
	AAllBrands, ABrand, ABrandFilter, AEmptyBrand
};

